import React from 'react';
import Shimmer from './Shimmer';

const LeisureShimmer = () => (
    <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Titre principal */}
            <Shimmer className="h-12 w-96 mx-auto rounded mb-16"/>

            {/* Catégories de loisirs */}
            <div className="space-y-32">
                {[1, 2, 3].map((categoryIndex) => (
                    <div key={categoryIndex} className="relative">
                        {/* En-tête de catégorie */}
                        <div className="flex flex-col items-center text-center mb-16">
                            <Shimmer className="w-12 h-12 rounded-full mb-4"/>
                            <Shimmer className="h-8 w-64 rounded"/>
                        </div>

                        {/* Grille d'activités */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                            {[1, 2].map((activityIndex) => (
                                <div key={activityIndex}
                                     className="relative border-l-4 border-[#228B22] pl-6">
                                    {/* Titre de l'activité */}
                                    <Shimmer className="h-8 w-3/4 rounded mb-3"/>

                                    {/* Description */}
                                    <Shimmer className="h-4 w-full rounded mb-2"/>
                                    <Shimmer className="h-4 w-5/6 rounded mb-4"/>

                                    {/* Lien */}
                                    <Shimmer className="h-4 w-32 rounded"/>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default LeisureShimmer;